module.exports = __webpack_public_path__ + "img/shopcart.04ea91f4.svg";